import BaseRoute from 'seshy/routes/base';

export default class AuthenticatedTeamsShowMembersRoute extends BaseRoute {}
